import {REPORT_EXPIRING_WELLNESS} from '/enum/records.enum';

export default {
  reportName: REPORT_EXPIRING_WELLNESS,
};
